import ConventionCollective from './convention-collective/convention-collective';
import Ressource from './ressource/ressource';
import PortraitAdherent from './portrait-adherent/portrait-adherent';
import SearchInput from './search-input/search-input';
import GlobalSearch from './global-search/global-search';
import SearchSection from './global-search/search-section';
import PageListing from './page/page-listing';

export default function initSearchBlocks() {
  customElements.define('convention-collective', ConventionCollective);
  customElements.define('ressources-results', Ressource);
  customElements.define('portrait-adherent', PortraitAdherent);
  customElements.define('search-input', SearchInput);
  customElements.define('global-search', GlobalSearch);
  customElements.define('search-section', SearchSection);
  customElements.define('page-listing', PageListing);
}